import { api } from './api.js';
import { $, wireCopyButtons, wireSkipLink } from './dom.js';
import { initMotion } from './landing-motion.js';
import type { CreateSessionResponse } from './types.js';

const RATE_LIMITED = 'Too many sessions from your network. Try again in an hour.';

function init(): void {
  const buttons = [...document.querySelectorAll<HTMLButtonElement>('[data-create]')];
  if (buttons.length === 0) return; // 404 page safety
  const labels = buttons.map((b) => b.textContent ?? 'Create secure agent session');
  const errorEl = $('create-error');

  wireCopyButtons();
  wireSkipLink();
  initMotion();

  const setBusy = (busy: boolean) =>
    buttons.forEach((b, i) => {
      b.disabled = busy;
      b.textContent = busy ? 'Creating…' : labels[i]!;
    });

  const create = async () => {
    setBusy(true);
    errorEl.hidden = true;

    const res = await api<CreateSessionResponse>('POST', '/api/v1/sessions');
    if (!res.ok) {
      setBusy(false);
      errorEl.textContent = res.status === 429 ? RATE_LIMITED : res.error.message;
      errorEl.hidden = false;
      errorEl.scrollIntoView({ block: 'center' });
      return;
    }

    const { session_link, agent_prompt, expires_at } = res.data;
    $<HTMLInputElement>('session-link').value = session_link;
    $<HTMLTextAreaElement>('agent-prompt').value = agent_prompt;
    $<HTMLAnchorElement>('open-viewer').href = session_link;
    const expires = new Date(expires_at);
    const time = $<HTMLTimeElement>('expires-at');
    time.dateTime = expires.toISOString();
    time.textContent = expires.toLocaleString();

    $('result').hidden = false;
    buttons.forEach((b) => (b.hidden = true));
    const title = $('result-title');
    title.focus();
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    title.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  };

  buttons.forEach((b) => b.addEventListener('click', create));
}

init();
